import * as yup from 'yup';

function effectiveStartDate(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'EFFECTIVE_START_DATE_IS_REQUIRED',
      defaultMessage: 'Effective Start Date is required',
    }),
  );
}

function effectiveEndDate(formatMessage) {
  return yup
    .string()
    .nullable()
    .test(
      'end-date-not-before-start-date',
      formatMessage({
        id: 'EFFECTIVE_END_DATE_CANNOT_BE_LESS_THAN_EFFECTIVE_START_DATE',
        defaultMessage:
          'Effective End Date cannot be less than Effective Start Date',
      }),
      (value, context) => {
        if (!value) {
          return true;
        }
        const { effectiveStartDate: startDateValue } = context.parent;
        if (!startDateValue) {
          return true;
        }
        return new Date(value) >= new Date(startDateValue);
      },
    );
}

const validationSchema = formatMessage =>
  yup
    .object({
      effectiveStartDate: effectiveStartDate(formatMessage),
      effectiveEndDate: effectiveEndDate(formatMessage),
    })
    .required();

export default validationSchema;
